<template>
      <tr :class="$style['pt-form-list-item']" >
          <td :class="$style['label-text']" align="right" ref="td" :style="{width:widthMax+'px'}">
              <div :class="$style['label-content']" :style="{lineHeight:lineHeight+'px',color:'#222'}">
                <div :class="$style['is-required']" v-if="required">*</div>
                  {{label}}
              </div>
          </td>
          <td :class="$style['label-slot']"><slot/></td>
      </tr>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-form-list-item'
export default {
  name: 'pt-form-list-item',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    lineHeight: {
      type: [Number, String],
      default: 40
    },
    required: {
      type: Boolean,
      default: false
    },
    widthArr: {
      type: Array,
      default: function () {
        return []
      }
    },
    widthMax: {// 所有子模块中的最大值
      type: [Number, String],
      default: ''
    }
  },
  data () {
    return {
      width_item: ''
    }
  },
  watch: {
    width_item (val) {
      // 1、子模块样式。所有子模块的label右对齐
      // a、每个子模块中，随意挑选一个pt-form-list-item（因为同一个子模块，label的宽度是相等的）,调用widthItem方法，在此方法中，将每一次获取的宽度push进一个数组。
      // b、取出数组中的最大值，在每个子模块中，随意挑选一个pt-form-list-item，将最大值（widthMax）传入
      this.$emit('widthItem', val)
    }
  },
  created () {
    this.$nextTick(_ => {
      // 获取第一个td即label部分的宽度
      this.width_item = this.$refs.td && this.$refs.td.getBoundingClientRect() && this.$refs.td.getBoundingClientRect().width
    })
  },
  destroyed () {
    this.width_max = null
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-form-list-item{
    width: 100%;
    td{
        padding-bottom: 20px;
    }
}
.label-text{
    display: flex;
    justify-content: flex-end;
    margin-right: 10px;
    white-space:nowrap;
    font-size: 15px;
}
.label-content{
    display: flex
}
.is-required{
    color: red!important;
    margin-right: 3px;
}
.label-slot{
    width: 100%;
}
</style>
